import { keyOf, isKey, setWindowLocationHref } from '../helpers.js'

export default function WebPageCommands(context) {
    let { settings, evaluate } = context;

    function Navigate(url, isPopup = false, features = ''){
        if (typeof isPopup === 'string') {
            features = isPopup;
            isPopup = true;
        }

        if (IsMobileView()) { evaluate(['Minimize']); }
        if (isPopup) { window.open(url, '_blank', features).focus(); }
        else { setWindowLocationHref(url); }
    }

    function CloseWindow(w=window) {
        return (w && typeof w.close === 'function') ? w.close() : null;
    }

    function IsMobileView() {
        let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return windowWidth <= (settings.Mobile || {}).breakpoint;
    }

    let valueProp = (elem) => {
        let tag  = (elem && elem.tagName && keyOf(elem.tagName));
        let type = (tag === 'input' && keyOf(elem.type));
        return ['radio', 'checkbox'          ].includes(type) ? 'checked' :
               ['input', 'textarea', 'button'].includes(tag ) ? 'value'
                                                              : null
    };

    function Element(element, value) {
        let isObj = (element && typeof element === 'object' && !Array.isArray(element));
        let elem  = (isObj       ) ? element :
                    isKey(element) ? document.querySelector(String(element))
                                   : null;
        let prop = valueProp(elem);
        let val  = (prop === 'checked') ? !!value : value;
        if (prop && arguments.length > 1) { elem[prop] = val; }
        return elem;
    }

    function Value(element, value) {
        let elem = Element(...arguments);
        let prop = valueProp(elem);
        let val  = (prop) ? elem[prop] : (elem && elem.textContent);
        let isTC = (!prop && typeof val === 'string');
        return (isTC) ? val.trim() : val;
    }

    function Click(element) {
        let e = Element(element);
        return !!(e && typeof e.click === 'function' && (e.click() || true));
    }

    return { Navigate, CloseWindow, IsMobileView, Element, Value, Click };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/commands/webpage.js